<script lang="ts" setup>
import { useDefaultAvatar, usePreviewImg } from "@/use/common";
import { Image, TextEllipsis } from "vant";
import { computed } from "vue";
import { getDisplayDateTime } from "@/modules/common";
import { StoryBook } from "@/types/entity";

const props = defineProps<{
  storyBook: StoryBook;
  showDraft?: boolean;
}>();

const isGenerating = computed(() => {
  return !props.storyBook.description;
});
</script>
<template>
  <div class="flex flex-col py-2">
    <div class="relative">
      <Image
        :class="{ 'bg-primary': true }"
        :src="
          storyBook.media
            ? usePreviewImg(storyBook.media.url)
            : useDefaultAvatar()
        "
        class="w-full aspect-[1/1] object-cover"
        fit="cover"
        crossorigin="anonymous"
      />
      <div v-if="isGenerating" class="absolute right-0 top-1 badge">
        {{ $t("story.processing") }}
      </div>
      <div
        v-else-if="showDraft && !storyBook.dtPublish"
        class="absolute right-0 top-1 badge"
      >
        {{ $t(`story.draft`) }}
      </div>
      <p
        class="absolute left-0 right-0 bottom-1 text-base h-8 leading-8 text-center bg-[rgba(0,0,0,0.5)] whitespace-nowrap overflow-hidden text-ellipsis text-white px-2"
      >
        {{ storyBook.title }}
      </p>
    </div>
    <div class="flex flex-col flex-grow gap-1 h-full overflow-hidden">
      <text-ellipsis
        :content="
          isGenerating ? $t('story.generateTimeMinutes') : storyBook.description
        "
        class="text-base-content/50 px-1 text-xs"
        rows="4"
      />
      <div v-if="isGenerating" class="text-base-content/50">
        {{ $t("story.generateTimeMinutes") }}：{{
          getDisplayDateTime(storyBook.dtCreate)
        }}
      </div>
    </div>
  </div>
</template>
